<template>
    <div>
        <app-page-header></app-page-header>
        <v-container  grid-list-xl class="box">
            <v-layout row wrap align-center justify-center fill-height>
                <v-flex xs12 sm12 md10 lg10 xl8>
                    <registration-number-retention-time></registration-number-retention-time>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

const RegistrationNumberRetentionTime = () => import('@/components/RegistrationNumberRetentionTime.vue');

export default {
    components: {
        RegistrationNumberRetentionTime
    },

    data: () => ({

    }),

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
    },

    mounted() {
        
    },

    destroyed() {

    }
}

</script>

<style scoped>
    .btn_rfid {
        margin-right:10px;
    }

    .v-card__text {
        color: rgba(0,0,0,0.90) !important;
    }
</style>